import { render, staticRenderFns } from "./PrivateFilesOnContactPage.vue?vue&type=template&id=22f9ba8c&scoped=true&"
import script from "./PrivateFilesOnContactPage.vue?vue&type=script&lang=js&"
export * from "./PrivateFilesOnContactPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivateFilesOnContactPage.vue?vue&type=style&index=0&id=22f9ba8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f9ba8c",
  null
  
)

export default component.exports